import { render } from "./BaseCard.vue?vue&type=template&id=1d7017d6&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=1d7017d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d7017d6"

export default script